module.exports = __webpack_public_path__ + "img/spot-green-4.png";